<template>
  <Document
    v-if="step.files.length > 0"
    :step="step"
    :pdf="step.files.find((file) => file.type === 'document')"
  />
</template>
<script setup>
import Document from "./Document.vue";

const { step } = defineProps({ step: Object });
</script>
